export var KeyMap = {
    Up: "ArrowUp",
    Down: "ArrowDown",
    Left: "ArrowLeft",
    Right: "ArrowRight",
    Space: " ",
    Enter: "Enter",
    Esc: "Escape",
    Backspace: "Backspace",
    Tab: "Tab",
};
//# sourceMappingURL=key-map.js.map